import { render, staticRenderFns } from "./OpcionImg.vue?vue&type=template&id=c8763266"
import script from "./OpcionImg.vue?vue&type=script&lang=js"
export * from "./OpcionImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports